import { useEffect } from "react";
import { useReduxDispatch, useReduxSelector } from "../../redux/hooks";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import RevelationIframe from "../Revelation/RevelationIframe";
import { updateIframeSrc } from "../../slices/RevelationSlice";
import { Api } from "../../redux/api/BaseApi";
import { Spinny } from "./Spinny";
import { Setting } from "../../types/Setting/Setting";
import { UserApi } from "../../redux/api/UserApi";

const Deeplink = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const location = useLocation();
  const lowerParams = new URLSearchParams(
    [...searchParams].map(([key, value]) => [key.toLowerCase(), value])
  );
  const dispatch = useReduxDispatch();
  const { data } = Api.useGetUserProfileQuery();
  const { data: newTicketPageSetting } = UserApi.useGetSettingQuery(Setting.NEW_TICKET_DETAILS);

  // Redux Selectors
  const revI = useReduxSelector((state) => state.revI);


  useEffect(() => {
    if (data && newTicketPageSetting) {

      //Make sure that /deeplink isn't being opened inside the iframe
      console.log('Top check', window.top, 'equal', window.top === window.self);
      if (window.top !== window.self) {
        window.top.location = window.self.location;
        return;
      }

      var redirect = lowerParams.get("url") || lowerParams.get("returnurl");

      if (redirect) {
        //New Ticket details page
        //newTicketPageSetting?.Bool_Value
        if (newTicketPageSetting?.Bool_Value && redirect?.toLocaleLowerCase().indexOf('callhistory.aspx') > -1) {

          // for (const [key, value] of new URLSearchParams(new URL(window.top.location.origin + redirect).search).entries()) {
          //   console.log(`${key}, ${value}`);
          // }
          //Get the Id from the querystring 'call_id=12345'
          const queryString = new URL(window.top.location.origin + redirect).search;
          const params = new URLSearchParams(queryString?.toLocaleLowerCase())
          const dataItem = params?.get('call_id');
          const from = params?.get('from');
          if (from?.toLocaleLowerCase() !== 'newdetails') {
            params.delete("call_id")
            navigate(`/ticket/${dataItem}${queryString.length > 0 ? `/?${params}` : ''}`);
            return;
          }
        }


        navigate('/');
        dispatch(
          updateIframeSrc(redirect)
        );
      } else {
        console.log('window.history.replaceState', location.pathname + location.search)
        dispatch(updateIframeSrc(location.pathname + location.search))

        window.history.replaceState(null, '', '.');
      }
    }
  }, [data, newTicketPageSetting]);

  if (!revI?.currentIframeSrc) return <Spinny />

  return <RevelationIframe />;
};

export default Deeplink;
